import styled from "styled-components";
import theme from "../../style/theme";
import SearchLineIcon from "../icons/SearchLineIcon/SearchLineIcon";

interface Props {
  placeholder: string;
  name?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  width: string;
  isError?: boolean;
}

export const IconTextField: React.FC<Props> = ({
  placeholder,
  name,
  value,
  onChange,
  width,
  isError,
}) => {
  const resetPlaceholder =
    () => (event: React.FocusEvent<HTMLInputElement>) => {
      event.target.placeholder = placeholder;
    };

  return (
    <TextFieldContainer width={width}>
      <TextField
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={resetPlaceholder}
        isError={isError}
      />
      <LeftIconWarpper>
        <SearchLineIcon />
      </LeftIconWarpper>
    </TextFieldContainer>
  );
};

interface TextFieldContainerProps {
  width: string;
}

const TextFieldContainer = styled.div<TextFieldContainerProps>`
  position: relative;
  width: ${(props) => props.width}};
`;

interface TextFieldProps {
  isError?: boolean;
}

const TextField = styled.input<TextFieldProps>`
  width: 100%;
  height: 2.625rem;
  padding: 0 0 0 2.313rem;
  border: 1px solid
    ${(props) =>
      props.isError
        ? theme.palette.primitives.red500
        : theme.palette.primitives.gray300};
  border-radius: 4px;
  background: #ffffff;
  font-style: normal;
  font-weight: 400;
  font-size: 0.938rem;
  line-height: 1.125rem;
  color: ${theme.palette.primitives.black};
  box-sizing: border-box;
  outline: none;
  &::placeholder {
    color: ${theme.palette.primitives.gray300};
  }
  &:focus {
    border: 1px solid
      ${(props) =>
        props.isError
          ? theme.palette.primitives.red500
          : theme.palette.primitives.yellow400};
  }
`;

const LeftIconWarpper = styled.div`
  position: absolute;
  width: 1.125rem;
  height: 1.125rem;
  box-sizing: border-box;
  top: 50%;
  transform: translateY(-60%);
  left: 0.75rem;
`;
